import * as React from "react";
import { Announcement, AnnouncementProps } from "../../components/Announcement";
import { makeStyles } from "@fluentui/react-components";
import { flexColumn } from "../../styles/GlobalStyles";

const useStyles = makeStyles({
    container: {
        ...flexColumn,
        width: "100%",
        padding: "10px"
    }
});

export interface AnnouncementListProps
{
}

const announcements: AnnouncementProps[] = [
    {
        id: "3",
        title: "Ianus Guard custom product properties are now live!",
        date: new Date(2025, 8, 14, 12, 0, 0).toString(),
        previewContent: <img
          src="/assets/announcement/release.png"
          alt="Fireworks"
          style={{ objectFit: "none", maxHeight: "200px" }}
        />
    },
    {
        id: "2",
        title: "Ianus Guard telemetry features are now live!",
        date: new Date(2025, 8, 4, 18, 0, 0).toString(),
        previewContent: <img
          src="/assets/announcement/release.png"
          alt="Fireworks"
          style={{ objectFit: "none", maxHeight: "200px" }}
        />
    },
    {
        id: "1",
        title: "Ianus Guard is Live!",
        date: new Date(2025, 7, 2, 8, 0, 0).toString(),
        previewContent: <img
          src="/assets/announcement/release.png"
          alt="Fireworks"
          style={{ objectFit: "none", maxHeight: "200px" }}
        />
    }
];

export const AnnouncementList: React.FC<AnnouncementListProps> = () =>
{
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <h1>Announcements</h1>
            <br />
            { announcements.map( a => <Announcement key={a.id} {...a} /> ) }
        </div>
    )
};
